// extracted by mini-css-extract-plugin
export default {"cards":"events_cards__JYDNd"};